document.addEventListener('DOMContentLoaded', () => {
  const productForms = document.querySelectorAll('.product-form-snippet form');
  if (!productForms.length) return;

  productForms.forEach(productForm => {
    let hasClickedAddToCartWithoutSize = false;
    const variantList = productForm.querySelectorAll('.product-variant-grid');
    const addToCartBtn = productForm.querySelector('.product-add-to-cart-button');
    const addToCartBtnText = addToCartBtn ? addToCartBtn.querySelector('span') : null;
    const originalAddToCartText = (addToCartBtn && addToCartBtn.getAttribute('data-add-to-cart-text')) || (addToCartBtnText ? addToCartBtnText.textContent.trim() : 'Add to cart');
    const urgencyMsg = productForm.querySelector('.product-selling-fast');
    const hiddenInput = productForm.querySelector('input[name="id"]');
    const errorGrid = productForm.querySelector('.grid-error');

    const qtyInput = productForm.querySelector('#quantity');
    const qtyMinus = productForm.querySelector('.qty-minus');
    const qtyPlus = productForm.querySelector('.qty-plus');

    const stickyAtc = document.querySelector('.product-sticky-atc');
    const productSection = productForm.closest('.product') || productForm.closest('[class*="section-product"]');
    const originalAddWrap = productForm.querySelector('.product-add-wrap');
    const variantPicker = productForm.querySelector('.product-variant-wrap') || productForm.querySelector('.product-size-header');
    const stickyBtn = stickyAtc ? stickyAtc.querySelector('.sticky-atc-btn') : null;
    const stickyBtnText = stickyBtn ? stickyBtn.querySelector('span') : null;
    const stickyWishlistBtn = stickyAtc ? stickyAtc.querySelector('.sticky-wishlist-btn') : null;
    const originalWishlistBtn = productForm.querySelector('.product-wishlist-btn:not(.sticky-wishlist-btn)');

    // Toggle .has-value class on gift form inputs
    const giftInputs = productForm.querySelectorAll('.gift-input');
    giftInputs.forEach(input => {
      const checkValue = () => {
        if (input.value.trim() !== '') {
          input.classList.add('has-value');
        } else {
          input.classList.remove('has-value');
        }
      };
      input.addEventListener('input', checkValue);
      input.addEventListener('blur', checkValue);
      input.addEventListener('change', checkValue);
      checkValue();
    });

    const giftDateInput = productForm.querySelector('#gift-date');
    if (giftDateInput) {
      const initFlatpickr = () => {
        if (typeof flatpickr !== 'undefined') {
          flatpickr(giftDateInput, {
            disableMobile: true,
            dateFormat: "d/m/Y",
            position: "below",
            monthSelectorType: "static"
          });
        } else {
          setTimeout(initFlatpickr, 50);
        }
      };
      initFlatpickr();
    }

    function checkGiftFormCompletion() {
      const giftToggle = productForm.querySelector('.js-gift-packaging-checkbox');
      if (!giftToggle || !giftToggle.checked) {
        return true;
      }

      // Check email
      const emailInput = productForm.querySelector('#gift-email');
      if (emailInput) {
        const emailVal = emailInput.value.trim();
        if (emailVal === '') return false;
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(emailVal)) return false;
      }

      // Check name
      const nameInput = productForm.querySelector('#gift-name');
      if (nameInput && nameInput.value.trim() === '') return false;

      return true;
    }

    function updateButtonState() {
      if (addToCartBtn) addToCartBtn.dataset.soldOut = 'false';
      if (addToCartBtn && addToCartBtn.getAttribute('data-coming-soon') === 'true') {
        addToCartBtn.disabled = false;
        addToCartBtn.classList.remove('disabled');
        addToCartBtn.classList.remove('cta-btn--primary');
        addToCartBtn.classList.add('cta-btn--secondary');
        if (addToCartBtnText) {
          addToCartBtnText.textContent = 'Coming soon, notify me';
        }
        syncStickyBtnState();
        return;
      }

      const activeVariant = productForm.querySelector('.product-variant-grid.active');
      const variantId = addToCartBtn.getAttribute('data-id') || (hiddenInput ? hiddenInput.value : '');

      let isSoldOut = false;
      if (activeVariant) {
        if (activeVariant.classList.contains('variant-unavailable')) {
          isSoldOut = true;
        }
      } else if (variantList.length === 0) {
        isSoldOut = addToCartBtn && addToCartBtn.getAttribute('data-available') === 'false';
      }

      const isGiftComplete = checkGiftFormCompletion();

      if (!variantId) {
        addToCartBtn.disabled = false;
        addToCartBtn.classList.remove('disabled');
        addToCartBtn.classList.remove('cta-btn--secondary');
        addToCartBtn.classList.add('cta-btn--primary');
        if (addToCartBtnText) {
          addToCartBtnText.textContent = hasClickedAddToCartWithoutSize ? (addToCartBtn.getAttribute('data-select-text') || 'Select a size') : originalAddToCartText;
        }
      } else if (isSoldOut) {
        const canNotify = !!document.querySelector('.notify-popup');
        addToCartBtn.disabled = !canNotify;
        addToCartBtn.classList.add('disabled');
        addToCartBtn.classList.remove('cta-btn--primary');
        addToCartBtn.classList.add('cta-btn--secondary');
        addToCartBtn.dataset.soldOut = 'true';
        if (addToCartBtnText) addToCartBtnText.textContent = 'Sold out';
      } else if (!isGiftComplete) {
        addToCartBtn.disabled = true;
        addToCartBtn.classList.add('disabled');
        addToCartBtn.classList.remove('cta-btn--secondary');
        addToCartBtn.classList.add('cta-btn--primary');
        if (addToCartBtnText) addToCartBtnText.textContent = originalAddToCartText;
      } else {
        addToCartBtn.disabled = false;
        addToCartBtn.classList.remove('disabled');
        addToCartBtn.classList.remove('cta-btn--secondary');
        addToCartBtn.classList.add('cta-btn--primary');
        if (addToCartBtnText) addToCartBtnText.textContent = originalAddToCartText;
      }

      syncStickyBtnState();
    }

    // Register event listeners to update ATC state on gift inputs/checkbox updates
    const giftToggle = productForm.querySelector('.js-gift-packaging-checkbox');
    if (giftToggle) {
      giftToggle.addEventListener('change', updateButtonState);
    }
    giftInputs.forEach(input => {
      input.addEventListener('input', updateButtonState);
      input.addEventListener('change', updateButtonState);
    });

    // Initialize button state
    updateButtonState();

    if (variantList.length && addToCartBtn) {
      variantList.forEach(item => {
        item.addEventListener('click', function() {
          hasClickedAddToCartWithoutSize = false;
          variantList.forEach(li => {
            li.classList.remove('active');
            const btn = li.querySelector('.variant-option-btn');
            if (btn) btn.setAttribute('aria-pressed', 'false');
          });
          this.classList.add('active');
          const activeBtn = this.querySelector('.variant-option-btn');
          if (activeBtn) activeBtn.setAttribute('aria-pressed', 'true');

          const variantId = this.getAttribute('data-id');
          const inventory = parseInt(this.getAttribute('data-inventory') || '0');

          addToCartBtn.setAttribute('data-id', variantId);
          if (hiddenInput) {
            hiddenInput.value = variantId;
            hiddenInput.dispatchEvent(new Event('change', { bubbles: true }));
          }

          if (errorGrid) {
            errorGrid.innerHTML = '';
          }

          if (history.replaceState) {
            const newUrl = new URL(window.location.href);
            newUrl.searchParams.set('variant', variantId);
            window.history.replaceState({ path: newUrl.href }, '', newUrl.href);
          }

          if (urgencyMsg) {
            if (inventory > 5 && inventory < 10) {
              urgencyMsg.textContent = 'SELLING FAST';
              urgencyMsg.style.display = 'block';
            } else if (inventory <= 5 && inventory > 0) {
              urgencyMsg.textContent = `ONLY ${inventory} LEFT IN STOCK`;
              urgencyMsg.style.display = 'block';
            } else {
              urgencyMsg.style.display = 'none';
            }
          }

          updateButtonState();
        });
      });
    }

    if (qtyPlus && qtyInput) {
      qtyPlus.addEventListener('click', () => {
        qtyInput.value = parseInt(qtyInput.value, 10) + 1;
      });
    }

    if (qtyMinus && qtyInput) {
      qtyMinus.addEventListener('click', () => {
        const current = parseInt(qtyInput.value, 10);
        if (current > 1) qtyInput.value = current - 1;
      });
    }

    function addToCartHandler(e) {
      e.preventDefault();

      if (addToCartBtn && addToCartBtn.getAttribute('data-coming-soon') === 'true') {
        e.stopPropagation();
        if (typeof window.openNotifyPopup === 'function') {
          window.openNotifyPopup();
        }
        return;
      }

      if (addToCartBtn && addToCartBtn.dataset.soldOut === 'true') {
        e.stopPropagation();
        if (typeof window.openNotifyPopup === 'function') {
          window.openNotifyPopup();
        }
        return;
      }

      let variantId = addToCartBtn.getAttribute('data-id');
      if (!variantId && hiddenInput) {
        variantId = hiddenInput.value;
      }

      if (!variantId) {
        hasClickedAddToCartWithoutSize = true;
        updateButtonState();
        return;
      }

      const quantity = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;

      // Validate gift card properties if checkbox is checked
      const giftToggle = productForm.querySelector('.js-gift-packaging-checkbox');
      const properties = {};
      if (giftToggle && giftToggle.checked) {
        let isValid = true;
        const giftFields = productForm.querySelectorAll('.gift-field');
        
        giftFields.forEach(field => {
          field.classList.remove('has-error');
          const errMsg = field.querySelector('.gift-error-msg');
          if (errMsg) {
            errMsg.style.display = 'none';
            errMsg.textContent = '';
          }
        });

        // Validate Email
        const emailInput = productForm.querySelector('#gift-email');
        if (emailInput) {
          const emailVal = emailInput.value.trim();
          const emailField = emailInput.closest('.gift-field');
          const errMsg = emailField ? emailField.querySelector('.gift-error-msg') : null;
          if (emailVal === '') {
            isValid = false;
            if (emailField) emailField.classList.add('has-error');
            if (errMsg) {
              errMsg.textContent = 'This is a mandatory field.';
              errMsg.style.display = 'block';
            }
          } else {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailRegex.test(emailVal)) {
              isValid = false;
              if (emailField) emailField.classList.add('has-error');
              if (errMsg) {
                errMsg.textContent = 'Your email address is incorrect. Try again.';
                errMsg.style.display = 'block';
              }
            }
          }
        }

        // Validate Name
        const nameInput = productForm.querySelector('#gift-name');
        if (nameInput) {
          const nameVal = nameInput.value.trim();
          const nameField = nameInput.closest('.gift-field');
          const errMsg = nameField ? nameField.querySelector('.gift-error-msg') : null;
          if (nameVal === '') {
            isValid = false;
            if (nameField) nameField.classList.add('has-error');
            if (errMsg) {
              errMsg.textContent = 'This is a mandatory field.';
              errMsg.style.display = 'block';
            }
          }
        }

        if (!isValid) {
          const firstErrorField = productForm.querySelector('.gift-field.has-error');
          if (firstErrorField) {
            firstErrorField.scrollIntoView({ behavior: 'smooth', block: 'center' });
            const errInput = firstErrorField.querySelector('.gift-input');
            if (errInput) errInput.focus();
          }
          return;
        }

        // Populate properties payload if valid
        const propertyInputs = productForm.querySelectorAll('[name^="properties["]');
        propertyInputs.forEach(input => {
          if (input.type === 'checkbox' || input.type === 'radio') {
            if (input.checked) {
              const match = input.name.match(/properties\[(.*?)\]/);
              if (match) properties[match[1]] = input.value || 'yes';
            }
          } else {
            const match = input.name.match(/properties\[(.*?)\]/);
            if (match) properties[match[1]] = input.value;
          }
        });
      }

      addToCartBtn.disabled = true;
      syncStickyBtnState();

      const requestBody = { id: variantId, quantity: quantity };
      if (Object.keys(properties).length > 0) {
        requestBody.properties = properties;
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(requestBody)
      })
      .then(response => {
        if (!response.ok) return response.json().then(d => { throw d; });
        return response.json();
      })
      .then(() => {
        fetch('/cart.js')
        .then(resp => resp.json())
        .then(data => {
          if(typeof window.updateCartCountDisplay === 'function') {
            window.updateCartCountDisplay(data.item_count);
          } else {
            document.querySelectorAll('.cart-count').forEach(el => {
              if (window.innerWidth > 991) {
                el.innerHTML = '(' + data.item_count + ')';
              } else {
                el.innerHTML = data.item_count;
              }
            });
          }
        });

        if (window.innerWidth > 991) {
          if (typeof load_cart === 'function') {
            load_cart().then(() => {
              setTimeout(() => {
                if (typeof openCartDrawer === 'function') openCartDrawer();
              }, 100);
            });
          } else {
            setTimeout(() => {
              if (typeof openCartDrawer === 'function') openCartDrawer();
              else window.location.href = '/cart';
            }, 100);
          }
        } else {
          if (typeof load_cart === 'function') {
            load_cart();
          }
          if (typeof window.showCartNotification === 'function') {
            window.showCartNotification(variantId);
          }
        }
      })
      .catch(err => {
        console.error('Add to cart error:', err);
        if (err && err.description) {
          if (errorGrid) {
            errorGrid.innerHTML = err.description;
            setTimeout(() => { errorGrid.innerHTML = ''; }, 2000);
          } else {
            alert(err.description);
          }
        }
      })
      .finally(() => {
        updateButtonState();
      });
    }

    if (addToCartBtn) {
      addToCartBtn.addEventListener('click', addToCartHandler);
    }

    /* -----------------------------------------------------
       Sticky Add To Cart bar
       - Only visible while the .product section is within
         the viewport (both desktop and mobile). Once the
         user scrolls past the .product section entirely,
         the sticky bar hides.
       - Mobile: sticky to bottom
       - Desktop: sticky to top (below header) on scroll up
       - If no variant selected yet ("Select a size"): sticky
         button scrolls user to the variant picker instead of
         trying to add to cart.
       - If a variant is selected ("Add to cart"): sticky
         button behaves exactly like the main add-to-cart button.
    ----------------------------------------------------- */

    function isSelectSizeState() {
      // "Select a size" state = no variant id set yet
      const variantId = addToCartBtn.getAttribute('data-id') || (hiddenInput ? hiddenInput.value : '');
      return !variantId;
    }

    function syncStickyBtnState() {
      if (!stickyBtn || !addToCartBtn) return;

      stickyBtn.classList.add('cta-btn--light');

      if (addToCartBtn.getAttribute('data-coming-soon') === 'true') {
        stickyBtn.disabled = false;
        stickyBtn.classList.remove('disabled');
        stickyBtn.classList.remove('cta-btn--primary');
        stickyBtn.classList.add('cta-btn--secondary');
        if (stickyBtnText) {
          stickyBtnText.textContent = 'Coming soon, notify me';
        }
        stickyBtn.setAttribute('data-id', addToCartBtn.getAttribute('data-id') || '');
        return;
      }

      if (isSelectSizeState()) {
        // Show "Add to cart" state but keep it CLICKABLE so user can
        // jump down to the size selector.
        stickyBtn.disabled = false;
        stickyBtn.classList.remove('disabled');
        stickyBtn.classList.remove('cta-btn--secondary');
        stickyBtn.classList.add('cta-btn--primary');
        if (stickyBtnText) {
          stickyBtnText.textContent = originalAddToCartText;
        }
      } else {
        stickyBtn.disabled = addToCartBtn.disabled;
        stickyBtn.classList.toggle('disabled', addToCartBtn.classList.contains('disabled'));
        if (addToCartBtn.classList.contains('cta-btn--secondary')) {
          stickyBtn.classList.remove('cta-btn--primary');
          stickyBtn.classList.add('cta-btn--secondary');
        } else {
          stickyBtn.classList.remove('cta-btn--secondary');
          stickyBtn.classList.add('cta-btn--primary');
        }
        if (stickyBtnText && addToCartBtnText) {
          stickyBtnText.textContent = addToCartBtnText.textContent;
        }
      }

      stickyBtn.setAttribute('data-id', addToCartBtn.getAttribute('data-id') || '');
    }

    function stickyBtnClickHandler(e) {
      if (isSelectSizeState()) {
        e.preventDefault();
        hasClickedAddToCartWithoutSize = true;
        updateButtonState();
        const target = variantPicker || originalAddWrap;
        if (target) {
          target.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
        return;
      }
      addToCartHandler(e);
    }

    if (stickyAtc && originalAddWrap && productSection) {
      let inProductSection = false;
      let addWrapVisible = true;

      const thumbnailsContainer = document.querySelector('.product-images__thumbnails');
      const mainHeader = document.querySelector('.main-header');

      function updateThumbnailsTop() {
        if (window.innerWidth >= 992 && thumbnailsContainer) {
          let totalTop = 12; // base offset (12px)

          if (mainHeader) {
            const headerRect = mainHeader.getBoundingClientRect();
            if (headerRect.bottom > 0) {
              totalTop += headerRect.bottom;
            }
          }

          // If sticky ATC is visible
          if (stickyAtc && stickyAtc.classList.contains('is-visible')) {
            totalTop += stickyAtc.offsetHeight;
          }

          thumbnailsContainer.style.top = totalTop + 'px';
        }
      }

      updateThumbnailsTop();

      function updateStickyVisibility() {
        if (document.body.classList.contains('open-mc-drawer') || document.body.classList.contains('open-size-guide')) {
          stickyAtc.classList.remove('is-visible');
          updateThumbnailsTop();
          return;
        }

        if (inProductSection && !addWrapVisible) {
          stickyAtc.classList.add('is-visible');
        } else {
          stickyAtc.classList.remove('is-visible');
        }
        updateThumbnailsTop();
      }

      // Tracks whether the original add-to-cart wrap is currently visible
      const addWrapObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          addWrapVisible = entry.isIntersecting;
          updateStickyVisibility();
        });
      }, { threshold: 0 });

      addWrapObserver.observe(originalAddWrap);

      // Tracks whether the .product section itself is still within viewport
      const productSectionObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          inProductSection = entry.isIntersecting;
          updateStickyVisibility();
        });
      }, { threshold: 0 });

      productSectionObserver.observe(productSection);

      // Track scroll direction for desktop divider styling
      let lastScrollY = window.scrollY;

      window.addEventListener('scroll', () => {
        const currentScrollY = window.scrollY;
        if (currentScrollY > lastScrollY && currentScrollY > 0) {
          document.body.classList.add('scroll-down');
          document.body.classList.remove('scroll-up');
        } else {
          document.body.classList.add('scroll-up');
          document.body.classList.remove('scroll-down');
        }
        lastScrollY = currentScrollY;
        updateThumbnailsTop();
      }, { passive: true });

      // Sticky button: scroll-to-size-picker OR add-to-cart, depending on state
      if (stickyBtn) {
        stickyBtn.addEventListener('click', stickyBtnClickHandler);
      }



      // Keep sticky button text/disabled state in sync with the main button
      syncStickyBtnState();

      if (addToCartBtnText) {
        const btnTextObserver = new MutationObserver(syncStickyBtnState);
        btnTextObserver.observe(addToCartBtnText, { childList: true, characterData: true, subtree: true });
      }

      if (addToCartBtn) {
        const btnAttrObserver = new MutationObserver(syncStickyBtnState);
        btnAttrObserver.observe(addToCartBtn, { attributes: true, attributeFilter: ['disabled', 'class', 'data-id'] });
      }
    }
  });
});